import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import lazyLoadView from '@/util/lazyLoadView';

import SideNavSectionView from '../../../common/views/SideNavSectionView';
import LoadCustomerDetailsForm from '../../loaders/CustomerDetailsFormLoader';
import LoadCommands from '../../loaders/CommandsLoader';
import GetCustomerNotes from '../../services/GetCustomerNotes';
import SubmitCustomerCommunication from '../../services/SubmitCustomerCommunication';
import loadNotes from '../../../common/loaders/NotesLoader';
import CustomerNoteFileUploadTmpl from '../../../common/fileupload/CustomerNoteFileUploadTmpl.hbs';
import CustomerHeaderView from '../../views/CustomerHeaderView';

import tmplCustomerPage from './CustomerPage.hbs';
import './customerPage.css';

const customerPage = View.extend({
  template: tmplCustomerPage,

  className: 'customer-page container-fluid',

  ui: {
    sections: '.sections-container',
    customerHeader: '.customer-header'
  },

  regions: {
    sections: '@ui.sections',
    customerHeader: '@ui.customerHeader'
  },

  onRender() {
    const customerId = this.model.get('customerId');
    const customerDetails = this.model.get('customerDetails');
    this.showChildView(
      'customerHeader',
      new CustomerHeaderView({
        model: new Backbone.Model({
          id: customerId,
          ...customerDetails
        })
      })
    );

    this.showChildView(
      'sections',
      new SideNavSectionView({
        model: new Backbone.Model({
          customerId,
          returnLabel: 'Return to Dashboard',
          returnLink: '#dashboard'
        }),
        collection: new Backbone.Collection([
          {
            id: 'customerDetails',
            title: 'Details',
            loader: LoadCustomerDetailsForm,
            isSavable: false,
            loaderOptions: {
              customerId
            },
            view: lazyLoadView(() => LoadCustomerDetailsForm(customerId))
          },
          {
            id: 'commands',
            title: 'Commands',
            loader: LoadCommands,
            isSavable: false,
            loaderOptions: {
              customerId
            },
            view: lazyLoadView(() => LoadCommands(customerId))
          },
          {
            id: 'notes',
            title: 'Internal Notes',
            isSavable: false,
            loader: loadNotes,
            loaderOptions: {
              objectTypeId: 'CUSTOMER',
              editable: true,
              metadata: {
                customerId
              },
              objectId: customerId,
              getNotesService: GetCustomerNotes,
              submitNoteService: SubmitCustomerCommunication,
              submitNoteAttachmentService: CustomerNoteFileUploadTmpl,
              pathToFileId: 'html.head.script.Envelope.Body.UploadCustomerNoteAttachmentResponse.AttachmentID.__text'
            },
            view: lazyLoadView(() =>
              loadNotes({
                editable: true,
                metadata: {
                  customerId
                },
                objectId: customerId,
                getNotesService: GetCustomerNotes,
                submitNoteService: SubmitCustomerCommunication,
                submitNoteAttachmentService: CustomerNoteFileUploadTmpl,
                pathToFileId: 'html.head.script.Envelope.Body.UploadCustomerNoteAttachmentResponse.AttachmentID.__text'
              })
            )
          }
        ]),
        editable: true,
        useNavigationButtons: true
      })
    );
  }
});

export default customerPage;
